/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { ThemeProvider, StylesProvider } from '@material-ui/core';
import LandingPage from './components/landing/LandingPage';
import { useTheming, jss } from './shared/theming/useTheming';
import { ConfigResourceProps } from './redux/enums/ConfigResourceProps';
import { useAuth } from './redux/features/auth/useAuth';
import { useConfiguration } from './redux/features/configuration/useConfiguration';
import { ThunkStatus } from './redux/enums/ThunkStatus';

/**
 * Wrapper component that handles global concerns:
 *  - authentication (signing in)
 *  - global configuration resource fetching
 *  - MUI theme
 */
export default function AppInitializer(props) {
  const { status, userData } = useAuth();

  const theming = useTheming();
  const globalConfiguration = useConfiguration(ConfigResourceProps.GLOBAL_CONFIGURATION);

  if (status === ThunkStatus.SUCCEEDED && !userData && globalConfiguration.ready && theming.ready) {
    return (
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theming.theme}>
          <LandingPage />
        </ThemeProvider>
      </StylesProvider>
    );
  }

  if (status === ThunkStatus.SUCCEEDED && userData && globalConfiguration.ready && theming.ready) {
    return (
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theming.theme}>{props.children}</ThemeProvider>
      </StylesProvider>
    );
  }

  return null;
}
